var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiFlagFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E4E7DD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24323_40182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24323_40182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8332 17.6663V22.6663C11.8332 22.9025 11.7533 23.1004 11.5936 23.2601C11.4339 23.4198 11.2359 23.4997 10.9998 23.4997C10.7637 23.4997 10.5658 23.4198 10.4061 23.2601C10.2464 23.1004 10.1665 22.9025 10.1665 22.6663V10.1663C10.1665 9.93023 10.2464 9.73231 10.4061 9.57259C10.5658 9.41287 10.7637 9.33301 10.9998 9.33301H16.979C17.1734 9.33301 17.3471 9.39551 17.4998 9.52051C17.6526 9.64551 17.7498 9.80523 17.7915 9.99967L17.9998 10.9997H21.8332C22.0693 10.9997 22.2672 11.0795 22.4269 11.2393C22.5866 11.399 22.6665 11.5969 22.6665 11.833V18.4997C22.6665 18.7358 22.5866 18.9337 22.4269 19.0934C22.2672 19.2531 22.0693 19.333 21.8332 19.333H17.5207C17.3262 19.333 17.1526 19.2705 16.9998 19.1455C16.8471 19.0205 16.7498 18.8608 16.7082 18.6663L16.4998 17.6663H11.8332Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFlagFilled);
export default __webpack_public_path__ + "static/media/ai-flag-filled.1263f553979b1f4841448bf2a9cac8c5.svg";
export { ForwardRef as ReactComponent };